import React, {useState, createRef } from "react";
import "./Contato.css";
import "../../Componentes/Loading/loading01.css";
import { Clock, Envelope, Whatsapp } from 'react-bootstrap-icons';
import MudaPagina from "../../Componentes/Util/Navegacao.js";
import axios from "axios"
import $ from "jquery"

export default function Contato () {
    const [loading, setLoading] = useState(false);
    const [nome, setNome] = useState('');
    const [email, setEmail] = useState('');
    const [telefone, setTelefone] = useState('');
    const [mensagem, setMensagem] = useState('');
    const [resposta, setResposta] = useState('');
    // const [values, setValues] = useState({
    //     nome: "",
    //     email: "",
    //     telefone: "",
    //     mensagem: ""
    // })
    // const formRef = createRef(null);
    // function handleInputChange(event){
    //     values[event.target.name] = event.target.value;
    //     setValues(values);
    //     console.log(event.target.name, " - values", values);
    // }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        // let data = {
        //     nome: values.nome,
        //     email: values.email,
        //     telefone: values.telefone,
        //     mensagem: values.mensagem,
        // }
        let data = {
            nome: nome,
            email: email,
            telefone: telefone,
            mensagem: mensagem,
        }
        //console.log("data", data);
        //return false;
        //resetForm(); 
        $(".formContato form").hide(150);
        await axios.post('https://api.construmarcas.com.br/api/enviaremail',
            // formData,
            data,
            {
              headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json; charset=UTF-8",
                //"Content-Type": `multipart/form-data; boundary=${formData._boundary}`,
              }
            }
        )
        .then(response => {
            $(".formContato form").show(150);
            setResposta(response.data);            
            resetForm(); 
            setTimeout(() => {
                setResposta("");
            }, 5000);

            setLoading(false);
            // setNome("");
            // setEmail("");
            // setTelefone("");
            // setMensagem("");
        })
        .catch((error) => {
            $(".formContato form").show(150);
            setResposta(error.data);
            resetForm();
            setTimeout(() => {
                setResposta("");
            }, 5000);

            setLoading(false);
        });  
    };   

    const resetForm = () => {
        setNome("");
        setEmail("");
        setTelefone("");
        setMensagem("");
        // formRef.current.reset();
        // setValues({
        //     nome: "",
        //     email: "",
        //     telefone: "",
        //     mensagem: "",
        // })
    }

    return (
        <div className="conteudo area-contatos">
            <div className="outrosContatos">
                <div className="contatos">
                    <h4>Atendimento</h4>
                    <ul className="infos">
                        <li><Clock size={24} color="#ff7b21"></Clock> Seg - Sex, das 7h às 17h</li>
                        <li className='link' onClick={() => MudaPagina("https://api.whatsapp.com/send?phone=5511950001834&text=Gostaria%20de%20mais%20informações.", "_blank")}><Whatsapp size={24} className='icone-redesocial'></Whatsapp> <b>(11) 95000-1834</b></li>
                        <li className='link' onClick={() => MudaPagina("mailto:vendas@construmarcas.com","_blank")}><Envelope size={24} className='icone-redesocial'></Envelope> vendas@construmarcas.com</li>
                    </ul>
                    </div>
                <img src="/imagens/Contato/img_contato.png" />
            </div>
            <div className="formContato">
                <form onSubmit={handleSubmit}>
                    <h4>Formulário de Contato</h4>
                    <span>Para melhor atendê-lo, entre em contato conosco através de nosso telefone de atendimento em horário comercial. Preencha o formulário abaixo ou, se preferir, envie-nos um email.</span>
                    <br /><br />
                    {resposta && <p className="respostaEmail">{resposta.mensagem}</p>}
                    <div>
                        <label>
                            Nome: <input type="text" value={nome} onChange={(e) => setNome(e.target.value)} placeholder="Digite seu nome" required />
                            {/* Nome: <input type="text" id="nome" name="nome" onChange={handleInputChange} placeholder="Digite seu nome" required /> */}
                        </label>
                        <label>
                            Telefone: <input type="tel" value={telefone} onChange={(e) => setTelefone(e.target.value)} placeholder="Digite seu telefone" required />
                            {/* Telefone: <input type="tel" id="telefone" name="telefone" onChange={handleInputChange} placeholder="Digite seu telefone" required /> */}
                        </label>
                    </div>
                    <label>
                        E-mail: <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Digite seu E-mail" required />
                        {/* E-mail: <input type="email" id="email" name="email" onChange={handleInputChange} placeholder="Digite seu E-mail" required /> */}
                    </label>
                    <label>
                        Mensagem: <textarea value={mensagem} onChange={(e) => setMensagem(e.target.value)} placeholder="Digite sua mensagem" required ></textarea>
                        {/* Mensagem: <textarea id="mensagem" name="mensagem" onChange={handleInputChange} placeholder="Digite sua mensagem" required ></textarea> */}
                    </label>
                    <button className="btn-enviar" type="submit">Enviar</button>
                </form>
                {(loading && <div className="loading01"></div>)}
            </div>
        </div>
    )
}